(function () {
  const KEY = "easy_wishlist";

  function getWishlist() {
    return JSON.parse(localStorage.getItem(KEY) || "[]");
  }

  function saveWishlist(items) {
    localStorage.setItem(KEY, JSON.stringify(items));
    updateCount();
    updateButtons();
  }

  function isAdded(handle) {
    return getWishlist().some(item => item.handle === handle);
  }

  function addItem(product) {
    let items = getWishlist();

    if (!items.some(item => item.handle === product.handle)) {
      items.push(product);
    }

    saveWishlist(items);
  }

  function removeItem(handle) {
    let items = getWishlist().filter(item => item.handle !== handle);
    saveWishlist(items);
    renderDrawer();
    renderWishlistPage();
  }

  function updateCount() {
    document.querySelectorAll(".ew-count").forEach(count => {
      count.textContent = getWishlist().length;
    });
  }

function updateButtons() {
  document.querySelectorAll(".ew-btn").forEach(btn => {
    const handle = btn.dataset.handle;

    // Check if button is on PDP
    const isPdp = btn.closest(".ew-pdp-wishlist");

    if (isAdded(handle)) {
      btn.classList.add("is-active");

      if (isPdp) {
        btn.innerHTML = "♥ Added to Wishlist";
      } else {
        btn.innerHTML = "♥";
      }

    } else {
      btn.classList.remove("is-active");

      if (isPdp) {
        btn.innerHTML = "♡ Add to Wishlist";
      } else {
        btn.innerHTML = "♡";
      }
    }
  });
}

  function createButton(product) {
    const btn = document.createElement("button");
    btn.className = "ew-btn";
    btn.type = "button";
   btn.innerHTML = "♡";

    btn.dataset.handle = product.handle;
    btn.dataset.title = product.title;
    btn.dataset.url = product.url;
    btn.dataset.image = product.image;
    btn.dataset.price = product.price;

    btn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      const data = {
        handle: btn.dataset.handle,
        title: btn.dataset.title,
        url: btn.dataset.url,
        image: btn.dataset.image,
        price: btn.dataset.price
      };

      if (isAdded(data.handle)) {
        removeItem(data.handle);
      } else {
        addItem(data);
      }
    });

    return btn;
  }

  function injectManualButtons() {
    document.querySelectorAll("[data-ew-product]").forEach(box => {
      if (box.querySelector(".ew-btn")) return;

      box.style.position = "relative";

      const product = {
        handle: box.dataset.handle,
        title: box.dataset.title,
        url: box.dataset.url,
        image: box.dataset.image,
        price: box.dataset.price
      };

      box.appendChild(createButton(product));
    });

    updateButtons();
  }

  function renderDrawer() {
    const list = document.querySelector(".ew-items-list");
    if (!list) return;

    const items = getWishlist();

    if (items.length === 0) {
      list.innerHTML = "<p>Your wishlist is empty.</p>";
      return;
    }

    list.innerHTML = items.map(item => `
      <div class="ew-item">
        <a href="${item.url}">
          <img src="${item.image}" alt="${item.title}">
        </a>
        <div>
          <a class="ew-item-title" href="${item.url}">${item.title}</a>
          <p>${item.price || ""}</p>
          <button class="ew-remove" data-remove="${item.handle}">Remove</button>
        </div>
      </div>
    `).join("");

    document.querySelectorAll("[data-remove]").forEach(btn => {
      btn.addEventListener("click", function () {
        removeItem(this.dataset.remove);
      });
    });
  }

  function renderWishlistPage() {
    const page = document.querySelector("#easy-wishlist-page");
    if (!page) return;

    const items = getWishlist();

    if (items.length === 0) {
      page.innerHTML = "<p>Your wishlist is empty.</p>";
      return;
    }

    page.innerHTML = items.map(item => `
      <div class="ew-item">
        <a href="${item.url}">
          <img src="${item.image}" alt="${item.title}">
        </a>
        <div>
          <a class="ew-item-title" href="${item.url}">${item.title}</a>
          <p>${item.price || ""}</p>
          <button class="ew-remove" data-remove="${item.handle}">Remove</button>
        </div>
      </div>
    `).join("");

    document.querySelectorAll("[data-remove]").forEach(btn => {
      btn.addEventListener("click", function () {
        removeItem(this.dataset.remove);
      });
    });
  }

  function drawerEvents() {
    const drawer = document.querySelector("easy-wish-drawer");
    if (!drawer) return;

    document.querySelectorAll(".ew-header-link").forEach(link => {
      link.addEventListener("click", function (e) {
        e.preventDefault();
        renderDrawer();
        drawer.classList.add("is-open");
      });
    });

    drawer.querySelector(".ew-close-btn")?.addEventListener("click", function () {
      drawer.classList.remove("is-open");
    });

    drawer.querySelector(".ew-overlay")?.addEventListener("click", function () {
      drawer.classList.remove("is-open");
    });
  }
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    injectManualButtons();
    drawerEvents();
    updateCount();
    renderWishlistPage();
  }, 500);
});

document.addEventListener("shopify:section:load", function () {
  setTimeout(function () {
    injectManualButtons();
    updateCount();
  }, 300);
});
})();